import { useCallback, useRef } from 'react';

export const useHiddenSeriesNames = () => {
  const hiddenSeriesNamesRef = useRef<string[]>([]);

  const handleLegendVisibilityChange = useCallback((seriesName: string) => {
    if (hiddenSeriesNamesRef.current.includes(seriesName)) {
      hiddenSeriesNamesRef.current = hiddenSeriesNamesRef.current.filter(hiddenSeriesName => hiddenSeriesName !== seriesName);
      return;
    }
    hiddenSeriesNamesRef.current = [...hiddenSeriesNamesRef.current, seriesName];
  }, []);

  const pruneHiddenSeriesNames = useCallback((seriesNames: string[]) => {
    const visibleSeriesNames = new Set(seriesNames);
    hiddenSeriesNamesRef.current = hiddenSeriesNamesRef.current
        .filter(hiddenSeriesName => visibleSeriesNames.has(hiddenSeriesName));
  }, []);

  return {
    hiddenSeriesNamesRef,
    handleLegendVisibilityChange,
    pruneHiddenSeriesNames,
  };
};
